<div class="content">
  <img src="assets/icon/check_circle.svg" class="green-check-circle" alt="" />
  <div class="text">
    <div class="header">
      <ng-content select="[header]"></ng-content>
    </div>
    <div class="body">
      <ng-content select="[body]"></ng-content>
    </div>
  </div>
</div>
